module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"reported_post":"私が申告/遮断した掲示物"}}')
  delete Component.options._Ctor
}
